import { useQueryClient } from '@tanstack/react-query';
import useMutationApi from 'src/api/useMutationApi';

export interface CreateCoreEnumData {
  name: string;
  description: string;
  isSystem?: boolean; // Only admins can set this
  areOptionsLocked?: boolean; // Only admins can set to true on creation
  options?: Array<{
    name: string;
    description?: string;
    sortOrder: number;
  }>;
}

export interface CoreEnumResponse {
  id: string;
  name: string;
  description: string;
  options?: Array<{
    id: string;
    name: string | null;
    description: string | null;
    sortOrder: number;
  }>;
}

const useCreateCoreEnum = (onSuccess?: () => void) => {
  const queryClient = useQueryClient();

  return useMutationApi<CreateCoreEnumData, CoreEnumResponse>({
    endpoint: 'core/core-enums',
    method: 'POST',
    successMessage: 'Enum created successfully',
    errorMessage: 'Failed to create enum',
    options: {
      onSuccess: () => {
        queryClient.invalidateQueries({ queryKey: ['core/core-enums'] });
        onSuccess?.();
      },
    },
  });
};

export default useCreateCoreEnum;
